import { StructuredProductEligibilityResponse, StructuredProductResponse } from '@blk/aw-bff-typescript-models';
import { AxiosResponse } from 'axios';
import { awBffApi } from './Base';

const PATH = '/sp-engine/structured-product';
const ELIGIBILITY_PATH = '/sp-engine/structured-product-eligibility';

export interface GetStructuredProductParams {
  analysisDate: string;
  ids: string[];
  pkg: string;
}

export const getStructuredProductResponse = (
  params: GetStructuredProductParams
): Promise<AxiosResponse<StructuredProductResponse>> =>
  awBffApi.get<StructuredProductResponse>(PATH, {
    params,
    paramsSerializer: { serialize: (params) => new URLSearchParams(params).toString() },
  });

export const getStructuredProductEligibilityResponse = (
  params: GetStructuredProductParams
): Promise<AxiosResponse<StructuredProductEligibilityResponse>> =>
  awBffApi.get<StructuredProductEligibilityResponse>(ELIGIBILITY_PATH, {
    params,
    paramsSerializer: { serialize: (params) => new URLSearchParams(params).toString() },
  });
